import { render, staticRenderFns } from "./itemsPriceHistory.vue?vue&type=template&id=6197d536"
import script from "./itemsPriceHistory.vue?vue&type=script&lang=js"
export * from "./itemsPriceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports